import { Menu } from '../menu/Menu'
import { useSistema } from '../../../hooks/useSistema'
import { useAPIService } from '../../../hooks/useAPIService'

export function MenuLateral(){
    const { usuario } = useSistema()
    const { getImagem } = useAPIService()

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4 sidebar-no-expand">
            <a href={process.env.REACT_APP_URL_SISTEMA} target="_blank" rel="noreferrer" className="brand-link text-sm">
                <img src={getImagem(process.env.REACT_APP_LOGO_MINI)} alt="Logo" className="brand-image img-circle elevation-3" />
                <span className="brand-text font-weight-light">{process.env.REACT_APP_NOME_SISTEMA}</span>
            </a>
            <div className="sidebar">
                <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <a href="/#" title={(usuario ? usuario.nome : '')} >
                            <img src={getImagem(usuario.foto)} alt="Foto Usuário" className="img-circle elevation-2" />
                        </a>
                    </div>
                    <div className="info">
                        <a href="/#" title={(usuario ? usuario.nome : '')}
                            className="d-block" >{(usuario ? usuario.nome : '')}</a>
                    </div>
                </div>
                <Menu />
            </div>
        </aside>
    )
}